import { Route, Routes } from 'react-router-dom';

import { EmailConfigurationContextProvider as EmailContext } from '../../../context';
import RouteWithTitle from '../../../routes/RouteWithTitle';
import { MULTIPLE_SUBMISSION_TEMPLATES } from '../helper/constants';
import TemplateSettings from '../TemplateSettings';

export const TemplateSettingsRoutes = () => (
  <Routes>
    <Route
      path="/email-template-settings"
      element={
        <RouteWithTitle title="Template Settings - Wisestep">
          <EmailContext>
            <TemplateSettings type="email" />
          </EmailContext>
        </RouteWithTitle>
      }
    />
    <Route
      path="/submission-template-settings"
      element={
        <RouteWithTitle title="Template Settings - Wisestep">
          <EmailContext>
            <TemplateSettings type="submission" />
          </EmailContext>
        </RouteWithTitle>
      }
    />
    <Route
      path="/excel-template-settings"
      element={
        <RouteWithTitle title="Template Settings - Wisestep">
          <EmailContext>
            <TemplateSettings type="excel" />
          </EmailContext>
        </RouteWithTitle>
      }
    />
    <Route
      path="/multiple-submission-template"
      element={
        <RouteWithTitle title="Template Settings - Wisestep">
          <EmailContext>
            <TemplateSettings type={MULTIPLE_SUBMISSION_TEMPLATES} />
          </EmailContext>
        </RouteWithTitle>
      }
    />
    <Route
      path="/download-template-settings"
      element={
        <RouteWithTitle title="Template Settings - Wisestep">
          <EmailContext>
            <TemplateSettings type="jobs" />
          </EmailContext>
        </RouteWithTitle>
      }
    />
  </Routes>
);
